/** Design tokens + theme. Neutral surfaces (auto light/dark), one accent, system font, rem sizing on a fixed 16px base. */
export const tokens = `
:host {
  all: initial;
  display: block;
  box-sizing: border-box;
  width: 100%;
  font: 400 16px/1.45 system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  -webkit-text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
  color-scheme: light dark;
  color: var(--wk-text);
  --wk-accent: #4f5bd5;
  --wk-accent-rgb: 79, 91, 213;
  --wk-accent-ink: #ffffff;
  --wk-ok: #16a34a;
  --wk-warn: #d97706;
  --wk-danger: #dc2626;
  --wk-radius: 1rem;
  --wk-radius-sm: .75rem;
  --wk-z: 2147483000;
  /* light (default) */
  --wk-bg: #ffffff;
  --wk-panel: #f4f5f7;
  --wk-panel-2: #e9ebef;
  --wk-text: #14161a;
  --wk-muted: #6b7280;
  --wk-line: rgba(0, 0, 0, .09);
  --wk-shadow: 0 10px 40px rgba(0, 0, 0, .14), 0 1px 3px rgba(0, 0, 0, .08);
  --wk-stage: #0f1114;
  --wk-scrim: rgba(255, 255, 255, .72);
}
@media (prefers-color-scheme: dark) {
  :host(:not([data-theme="light"])) {
    --wk-bg: #121418;
    --wk-panel: #1a1d23;
    --wk-panel-2: #23272f;
    --wk-text: #eef0f4;
    --wk-muted: #9aa3b3;
    --wk-line: rgba(255, 255, 255, .1);
    --wk-shadow: 0 10px 40px rgba(0, 0, 0, .5), 0 1px 3px rgba(0, 0, 0, .4);
    --wk-scrim: rgba(18, 20, 24, .72);
  }
}
:host([data-theme="dark"]) {
  --wk-bg: #121418;
  --wk-panel: #1a1d23;
  --wk-panel-2: #23272f;
  --wk-text: #eef0f4;
  --wk-muted: #9aa3b3;
  --wk-line: rgba(255, 255, 255, .1);
  --wk-shadow: 0 10px 40px rgba(0, 0, 0, .5), 0 1px 3px rgba(0, 0, 0, .4);
  --wk-scrim: rgba(18, 20, 24, .72);
}
*, *::before, *::after { box-sizing: border-box; }
button, input { font: inherit; color: inherit; }
button { cursor: pointer; -webkit-tap-highlight-color: transparent; touch-action: manipulation; border: 0; background: none; padding: 0; margin: 0; }
button:disabled { cursor: default; }
:focus { outline: none; }
:focus-visible { outline: 2px solid var(--wk-accent); outline-offset: 2px; }
svg { display: block; width: 1em; height: 1em; }
img, video { display: block; max-width: 100%; }
@keyframes wk-pulse { 0%, 100% { opacity: 1; } 50% { opacity: .35; } }
@keyframes wk-breathe { 0%, 100% { opacity: .55; } 50% { opacity: 1; } }
@keyframes wk-ripple { 0% { transform: scale(1); opacity: .5; } 100% { transform: scale(1.7); opacity: 0; } }
@keyframes wk-rise { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: none; } }
@keyframes wk-bounce { 0%, 80%, 100% { transform: translateY(0); } 40% { transform: translateY(-4px); } }
@keyframes wk-spin { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) {
  :host, :host * , :host *::before, :host *::after { animation: none !important; transition: none !important; }
}
`;
